import { SurveyCreator, SurveyCreatorComponent } from "survey-creator-react";
import "survey-creator-core/survey-creator-core.min.css";
import "survey-core/survey-core.css";
import "./SurveyBuilder.css";
// Registers custom SurveyJS question types + their React renderers.
import "./fields/ageDateRangeQuestion";
import "./fields/ageRangeYearQuestion";
import "./fields/assignDrugKitQuestion";
import "./fields/dispenseDrugKitQuestion";
import "./fields/dobAgeSelectorQuestion";
import "./fields/eq5dlQuestion";
import "./fields/singleCheckboxQuestion";
import "./fields/numericPadQuestion";
import "./fields/patientVisitSelectorQuestion";
import "./fields/radioButtonQuestion";
import "./fields/replaceDrugKitQuestion";
import "./fields/singleSelectCheckQuestion";
import "./fields/vasQuestion";
import "./fields/visitDatePickerQuestion";
import "./fields/headerTextQuestion";
import "./fields/paragraphQuestion";
import { SvgRegistry, Serializer } from "survey-core";
import ReactDOMServer from "react-dom/server";
import QuestionnaireSettings from "./QuestionnaireSettings";
import { AssignedDrugKitSelectorIcon } from "../../../../../assets/formBuilderIcons/AssignedDrugKitSelectorIcon";
import { DateIcon } from "../../../../../assets/formBuilderIcons/DateIcon";
import { TimeIcon } from "../../../../../assets/formBuilderIcons/TimeIcon";
import { DobAgeSelectorIcon } from "../../../../../assets/formBuilderIcons/DobAgeSelectorIcon";
import { registerDOBAgeSelectorQuestion } from "./fields/dobAgeSelectorQuestion";
import { Eq5dlIcon } from "../../../../../assets/formBuilderIcons/Eq5dlIcon";
import { SingleCheckBoxIcon } from "../../../../../assets/formBuilderIcons/SingleCheckBoxIcon";
import { AgeDateRangeIcon } from "../../../../../assets/formBuilderIcons/AgeDateRangeIcon";
import AgeRangeYearIcon from "../../../../../assets/formBuilderIcons/AgeRangeYearIcon";
import { NumericPadIcon } from "../../../../../assets/formBuilderIcons/NumericPadIcon";
import { PatientVisitSelectorIcon } from "../../../../../assets/formBuilderIcons/PatientVisitSelectorIcon";
import { RadioButtonIcon } from "../../../../../assets/formBuilderIcons/RadioButtonIcon";
import { RadioGroupIcon } from "../../../../../assets/formBuilderIcons/RadioGroupIcon";
import { registerGenderRadioGroupQuestion } from "./fields/groupRadioQuestion";
import { ReplaceDrugIcon } from "../../../../../assets/formBuilderIcons/ReplaceDrugIcon";
import { SingleSelectIcon } from "../../../../../assets/formBuilderIcons/SingleSelectIcon";
import {
  AGE_DATE_RANGE_TYPE,
  AGE_RANGE_YEAR_TYPE,
  ASSIGN_DRUG_KIT_TYPE,
  DISPENSE_DRUG_KIT_TYPE,
  DOB_AGE_SELECTOR_TYPE,
  EQ5DL_TYPE,
  GENDER_RADIO_TYPE,
  HEADER_TEXT_TYPE,
  NUMERIC_PAD_TYPE,
  PARAGRAPH_TEXT_TYPE,
  PATIENT_VISIT_SELECTOR_TYPE,
  REPLACE_DRUG_KIT_TYPE,
  SINGLE_CHECKBOX_TYPE,
  SINGLE_RADIO_TYPE,
  SINGLE_SELECT_CHECKBOX_TYPE,
  VAS_TYPE,
  VIDEO_PLAYER_TYPE,
  VISIT_DATE_PICKER_TYPE,
} from "./names";
import { VasIcon } from "../../../../../assets/formBuilderIcons/VasIcon";
import { VideoIcon } from "../../../../../assets/formBuilderIcons/VideoIcon";
import { registerVideoURLQuestion } from "./fields/videoQuestion";
import { registerSingleRadioQuestion } from "./fields/radioButtonQuestion";
import { VisitDatePickerIcon } from "../../../../../assets/formBuilderIcons/VisitDatePickerIcon";
import { getLocaleStrings, registerCreatorTheme } from "survey-creator-core";
import { customThemeVariables } from "./custom-theme";
import { addQuestionToToolBox, filterQuestions } from "./toolboxTypes";
import { HeaderTextIcon } from "../../../../../assets/formBuilderIcons/HeaderTextIcon";
import { registerHeaderTextQuestion } from "./fields/headerTextQuestion";
import { ParagraphIcon } from "../../../../../assets/formBuilderIcons/ParagraphIcon";
import { useEffect, useState, useRef, useCallback } from "react";
import { renamePanelInPropertyGrid, renamePanelToolboxItem } from "./helper";
import FieldDeleteModal from "./FieldDeleteModal";
import { QuestionnaireIcon } from "../../../../../assets/formBuilderIcons/QuestionnaireIcon";
import { v4 as uuidv4 } from "uuid";

const PRESERVE_KEYS = new Set([
  "id",
  "uid",
  "receivedId",
  "calculationJson",
  "rules",
  "meta",
]);

const customTheme = {
  themeName: "customTheme",
  cssVariables: { ...customThemeVariables },
};
const enLocale = getLocaleStrings("en");

function addCustomTheme(theme, userFriendlyThemeName) {
  enLocale.creatortheme.names[theme.themeName] = userFriendlyThemeName;
  registerCreatorTheme(theme);
}

addCustomTheme(customTheme, "Custom Theme");

const ageDateRangesvg = ReactDOMServer.renderToString(<AgeDateRangeIcon />);
const ageRangeSvg = ReactDOMServer.renderToString(<AgeRangeYearIcon />);
const svg = ReactDOMServer.renderToString(<AssignedDrugKitSelectorIcon />);
const dateIconSvg = ReactDOMServer.renderToString(<DateIcon />);
const timeIconSvg = ReactDOMServer.renderToString(<TimeIcon />);
const dobAgeSelectorSvg = ReactDOMServer.renderToString(<DobAgeSelectorIcon />);
const eq5dlSvg = ReactDOMServer.renderToString(<Eq5dlIcon />);
const singleCheckBoxSvg = ReactDOMServer.renderToString(<SingleCheckBoxIcon />);
const numericPadSvg = ReactDOMServer.renderToString(<NumericPadIcon />);
const patientVisitSvg = ReactDOMServer.renderToString(
  <PatientVisitSelectorIcon />,
);
const radioIconSvg = ReactDOMServer.renderToString(<RadioButtonIcon />);
const groupRadioIconSvg = ReactDOMServer.renderToString(<RadioGroupIcon />);
const replaceDrugIconSvg = ReactDOMServer.renderToString(<ReplaceDrugIcon />);
const singleSelectIconSvg = ReactDOMServer.renderToString(<SingleSelectIcon />);
const vasIconSvg = ReactDOMServer.renderToString(<VasIcon />);
const videoIconSvg = ReactDOMServer.renderToString(<VideoIcon />);
const visitDatePickerIconSvg = ReactDOMServer.renderToString(
  <VisitDatePickerIcon />,
);
const headerTextIconSvg = ReactDOMServer.renderToString(<HeaderTextIcon />);
const paragraphIconSvg = ReactDOMServer.renderToString(<ParagraphIcon />);

registerDOBAgeSelectorQuestion();
registerGenderRadioGroupQuestion();
registerVideoURLQuestion();
registerSingleRadioQuestion();
registerHeaderTextQuestion();
// registerVisitDatePickerQuestion();

SvgRegistry.registerIcon(
  "age-date-range-icon",
  ageDateRangesvg,
  undefined,
  true,
);
SvgRegistry.registerIcon("age-range-year-icon", ageRangeSvg, undefined, true);
SvgRegistry.registerIcon("hospital-icon", svg, undefined, true);
SvgRegistry.registerIcon("custom-date-icon", dateIconSvg, undefined, true);
SvgRegistry.registerIcon("custom-time-icon", timeIconSvg, undefined, true);
SvgRegistry.registerIcon(
  "custom-age-selector-icon",
  dobAgeSelectorSvg,
  undefined,
  true,
);
SvgRegistry.registerIcon("custom-eq5dl-icon", eq5dlSvg, undefined, true);
SvgRegistry.registerIcon(
  "custom-single-checkbox-icon",
  singleCheckBoxSvg,
  undefined,
  true,
);
SvgRegistry.registerIcon(
  "custom-numeric-pad-icon",
  numericPadSvg,
  undefined,
  true,
);
SvgRegistry.registerIcon(
  "custom-pateint-visit-icon",
  patientVisitSvg,
  undefined,
  true,
);
SvgRegistry.registerIcon(
  "custom-radio-button-icon",
  radioIconSvg,
  undefined,
  true,
);
SvgRegistry.registerIcon(
  "custom-radio-group-icon",
  groupRadioIconSvg,
  undefined,
  true,
);
SvgRegistry.registerIcon(
  "custom-replace-drug-icon",
  replaceDrugIconSvg,
  undefined,
  true,
);
SvgRegistry.registerIcon(
  "custom-single-select-icon",
  singleSelectIconSvg,
  undefined,
  true,
);
SvgRegistry.registerIcon("custom-vas-icon", vasIconSvg, undefined, true);
SvgRegistry.registerIcon("custom-video-icon", videoIconSvg, undefined, true);
SvgRegistry.registerIcon(
  "custom-visit-date-picker-icon",
  visitDatePickerIconSvg,
  undefined,
  true,
);
SvgRegistry.registerIcon(
  "custom-header-icon",
  headerTextIconSvg,
  undefined,
  true,
);
SvgRegistry.registerIcon("custom-para-icon", paragraphIconSvg, undefined, true);

export default function SurveyBuilder({
  questionnaireId,
  surveyJson,
  setSurveyJson,
  setLoad,
  loadQuestionData,
  showDeleteButton,
}) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showQuestionnairePanel, setShowQuestionnairePanel] = useState(false);

  const questionnairePanelRef = useRef(null);
  const selectedElement = useRef(null);
  const preservedSelectedElement = useRef(null);

  const creatorRef = useRef(null);
  if (!creatorRef.current) {
    creatorRef.current = new SurveyCreator({
      showLogicTab: false, // PAID
      showTranslationTab: false,
      showJSONEditorTab: false,
      isAutoSave: true, // PAID
      questionTypes: [
        "text",
        "checkbox",
        "dropdown",
        "panel",
        "ageDateRange",
        "ageRangeYear",
        "assignedDrugKit",
        "dispenseDrugKit",
        "dobAgeSelector",
        "eq5d5l",
        "singleCheckbox",
        "numericPad",
        "patientVisitDrugKitStatus",
        "singleradio",
        "genderRadioGroup",
        "replaceDrugKit",
        "singleSelectCheckbox",
        "vas",
        "videourl",
        "visitdatepicker",
        "headertext",
        "paragraphtext",
      ],
    });

    creatorRef.current.applyCreatorTheme(customTheme);
    // creatorRef.current.openCreatorThemeSettings();

    // Default survey structure (replaces createParent)
    if (surveyJson !== null && surveyJson) {
      creatorRef.current.JSON = surveyJson;
    } else {
      creatorRef.current.JSON = {
        // Hide the default SurveyJS header section (logo + title + description)
        // so the builder canvas starts directly with the page content.
        showTitle: false,
        title: "",
        description: "",
        logo: "",
        pages: [
          {
            name: "page1",
            title: "Page Container",
            elements: [],
          },
        ],
      };
    }
    // setSurveyJson(creatorRef?.current?.JSON);
  }

  const creator = creatorRef.current;

  useEffect(() => {
    renamePanelToolboxItem(creator);
    renamePanelInPropertyGrid(creator);
  }, []);

  // We don't allow editing Survey-level (root) properties like title/description.
  // Keep the Property Grid focused on builder elements (Page Container, questions, etc.)
  // by forcing selection to the first page and preventing the Survey object from being selected.
  useEffect(() => {
    const injectSidebarButton = () => {
      const container = document.querySelector(".svc-sidebar-tabs__items");
      if (!container) return;

      // Prevent duplicates
      if (container.querySelector("#questionnaire-sidebar-btn")) return;

      const action = document.createElement("div");
      action.className = "svc-menu-action";

      const button = document.createElement("div");
      button.id = "questionnaire-sidebar-btn";
      button.className = "svc-menu-action__button";
      button.title = "Control settings";
      button.tabIndex = 0;

      button.onclick = () => {
        // Preserve the currently selected element before opening the panel
        preservedSelectedElement.current = creator.selectedElement;
        setShowQuestionnairePanel((prev) => !prev);
      };

      const icon = document.createElement("div");
      icon.className = "svc-menu-action__icon";

      const iconContainer = document.createElement("div");
      iconContainer.className = "svc-menu-action__icon-container";

      iconContainer.innerHTML =
        document.getElementById("questionnaire-icon-svg")?.innerHTML || "";

      // Assemble tree
      icon.appendChild(iconContainer);
      button.appendChild(icon);
      action.appendChild(button);
      container.appendChild(action);
    };

    injectSidebarButton();

    const observer = new MutationObserver(injectSidebarButton);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  // For clicking outside the questionnaire settings panel to close it
  useEffect(() => {
    if (!showQuestionnairePanel) {
      // Clear the preserved selection when panel closes
      preservedSelectedElement.current = null;
      return;
    }

    const handleClickOutside = (event) => {
      if (
        questionnairePanelRef.current &&
        !questionnairePanelRef.current.contains(event.target)
      ) {
        setShowQuestionnairePanel(false);
        preservedSelectedElement.current = null;
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showQuestionnairePanel]);

  useEffect(() => {
    creator.onPropertyGridSurveyCreated.add((sender, options) => {
      if (options.obj) {
        // setSelectedElement(options.obj);
        selectedElement.current = options.obj;
      } else {
        // setSelectedElement(null);
        console.log("No object in Property Grid");
      }
    });
  }, [creator]);

  const ensurePageContainerExists = () => {
    const json = creator.JSON;
    if (!json.pages || json.pages.length === 0) {
      creator.JSON = {
        ...json,
        pages: [
          {
            name: "page1",
            title: "Page Container",
            elements: [],
          },
        ],
      };
    }
    return creator.survey?.pages?.[0] || null;
  };

  // Initialize page container only on mount
  useEffect(() => {
    const firstPage = ensurePageContainerExists();
    if (firstPage && !creator.selectedElement) {
      creator.selectedElement = firstPage;
    }
  }, [creator]);
  // Note: This runs only once during component mount, not on every re-render

  let isRedirectingSelection = false;
  creator.onSelectedElementChanged.add(() => {
    if (isRedirectingSelection) return;
    const page = ensurePageContainerExists();
    const survey = creator.survey;
    if (!survey || !page) return;

    if (creator.selectedElement === survey) {
      // If we have a preserved selected element (opening questionnaire panel),
      // restore it instead of redirecting to page
      if (preservedSelectedElement.current && showQuestionnairePanel) {
        isRedirectingSelection = true;
        creator.selectedElement = preservedSelectedElement.current;
        isRedirectingSelection = false;
      } else {
        isRedirectingSelection = true;
        creator.selectedElement = page;
        isRedirectingSelection = false;
      }
    }
  });

  const checkboxToolboxItem = creator.toolbox.items.find(
    (item) => item.json && item.json.type === "checkbox",
  );

  if (checkboxToolboxItem) {
    checkboxToolboxItem.title = "Multi Select Checkbox Control";
  }

  // Adding custom questions to the builder
  // useCallback(() => {
  addQuestionToToolBox(creator);
  // }, [creator]);

  // Removing any other auto-added / duplicate entries for the same question type.
  // useCallback(() => {
  filterQuestions(creator);
  // }, [creator]);

  // Remap property categories so the Property Grid shows only two tabs:
  // - "Control Options" (holds condition-like properties)
  // - "Settings" (holds everything else)
  // This makes it easy to add new properties later: set their category to
  // either "Control Options" or "Settings" (or leave as "general" and
  // we'll coerce it to "Settings" below).
  // Icons are applied via CSS in SurveyBuilder.css
  try {
    // Build a list of type names to normalize. Use common built-ins plus
    // the custom question types declared above so we pass strings to Serializer.findProperty.
    const builtInTypes = [
      "page",
      "text",
      "checkbox",
      "dropdown",
      "radiogroup",
      "file",
      "panel",
      "html",
      "image",
      "matrix",
      "boolean",
      "comment",
      "rating",
      "matrixdropdown",
      "matrixdynamic",
      "paneldynamic",
      "expression",
      "multipletext",
      "tagbox",
      "headertext",
      "paragraphtext",
    ];

    const customTypes = [
      AGE_DATE_RANGE_TYPE,
      AGE_RANGE_YEAR_TYPE,
      ASSIGN_DRUG_KIT_TYPE,
      DISPENSE_DRUG_KIT_TYPE,
      DOB_AGE_SELECTOR_TYPE,
      EQ5DL_TYPE,
      SINGLE_CHECKBOX_TYPE,
      NUMERIC_PAD_TYPE,
      PATIENT_VISIT_SELECTOR_TYPE,
      SINGLE_RADIO_TYPE,
      GENDER_RADIO_TYPE,
      REPLACE_DRUG_KIT_TYPE,
      SINGLE_SELECT_CHECKBOX_TYPE,
      VAS_TYPE,
      VIDEO_PLAYER_TYPE,
      VISIT_DATE_PICKER_TYPE,
      HEADER_TEXT_TYPE,
      PARAGRAPH_TEXT_TYPE,
    ];

    const allTypes = Array.from(new Set([...builtInTypes, ...customTypes]));
    const conditionProps = [
      "visibleIf",
      "enableIf",
      "requiredIf",
      "defaultValueExpression",
      "visible",
      "enable",
      "isRequired",
      "defaultValue",
    ];

    const commonProps = [
      "name",
      "title",
      "description",
      "placeholder",
      "readOnly",
      "inputType",
      "min",
      "max",
      "step",
      "choices",
      "choicesOrder",
      "showOtherItem",
      "otherText",
      "commentText",
    ];

    allTypes.forEach((type) => {
      // If Serializer exposes a properties list for the class, use it to
      // remap every property into the two categories. This ensures tabs like
      // "Layout" / "Choices" collapse into "Settings".
      if (typeof Serializer.getProperties === "function") {
        const props = Serializer.getProperties(type) || [];
        props.forEach((p) => {
          const propName = p && p.name ? p.name : p;
          if (conditionProps.includes(propName)) {
            const prop = Serializer.findProperty(type, propName);
            if (prop) {
              prop.category = "Control Options";
            }
          } else {
            const prop = Serializer.findProperty(type, propName);
            if (prop) {
              prop.category = "Settings";
            }
          }
        });
      } else {
        // Fallback: move conditionProps explicitly and coerce commonProps
        conditionProps.forEach((p) => {
          const prop = Serializer.findProperty(type, p);
          if (prop) {
            prop.category = "Control Options";
          }
        });

        commonProps.forEach((p) => {
          const prop = Serializer.findProperty(type, p);
          if (prop) {
            if (!prop.category || prop.category === "general") {
              prop.category = "Settings";
            }
          }
        });
      }
    });
  } catch (e) {
    // Swallow any errors - this mapping is best-effort and non-critical
    // eslint-disable-next-line no-console
    console.warn("Failed to remap SurveyJS property categories:", e);
  }

  // Function to add IDs to all elements in the survey
  // const addIdsToElements = (surveyJson) => {
  //   if (!surveyJson.pages) return surveyJson;

  //   const updatedJson = { ...surveyJson };
  //   updatedJson.pages = surveyJson.pages.map((page) => ({
  //     ...page,
  //     elements: page?.elements?.map((element, index) => {
  //       // If element doesn't have an id, generate one using name or index
  //       if (!element.id) {
  //         const uid = uuidv4();
  //         return {
  //           ...element,
  //           // id: element.name || `element_${index}_${Date.now()}`,
  //           id: element.name || `element_${index}_${Date.now()}`,
  //           uid: uid,
  //         };
  //       }
  //       return element;
  //     }),
  //   }));

  //   return updatedJson;
  // };

  // const addIdsToElements = (surveyJson) => {
  //   if (!surveyJson.pages) return surveyJson;

  //   const updatedJson = { ...surveyJson };

  //   updatedJson.pages = surveyJson.pages.map((page, pageIndex) => {
  //     // Add id + uid to page if missing
  //     const pageWithId = !page.id
  //       ? {
  //           ...page,
  //           id: page.name || `page_${pageIndex}_${Date.now()}`,
  //           uid: uuidv4(),
  //         }
  //       : page;

  //     return {
  //       ...pageWithId,
  //       elements: pageWithId?.elements?.map((element, index) => {
  //         // Add id + uid to element if missing
  //         if (!element.id) {
  //           return {
  //             ...element,
  //             id: element.name || `element_${index}_${Date.now()}`,
  //             uid: uuidv4(),
  //           };
  //         }
  //         return element;
  //       }),
  //     };
  //   });

  //   return updatedJson;
  // };

  // const addIdsToElements = (surveyJson) => {
  //   if (!surveyJson?.pages) return surveyJson;

  //   return {
  //     ...surveyJson,
  //     pages: surveyJson.pages.map((page, pageIndex) => {
  //       // 🔒 Preserve page identity
  //       const safePage = {
  //         ...page,
  //         id: page.id || page.name || `page_${pageIndex}`,
  //         uid: page.uid || uuidv4(), // ONLY generate if missing
  //       };

  //       return {
  //         ...safePage,
  //         elements: (safePage.elements || []).map((element, index) => {
  //           return {
  //             ...element,
  //             id: element.id || element.name || `element_${index}`,
  //             uid: element.uid || uuidv4(), // ONLY generate if missing
  //           };
  //         }),
  //       };
  //     }),
  //   };
  // };

  console.log("Sruev", surveyJson, creator.JSON);

  // Save hook (replaces save button logic)
  // creator.saveSurveyFunc = (saveNo, callback) => {
  //   let surveyJson = creator.JSON;
  //   // Add IDs to elements before saving
  //   surveyJson = addIdsToElements(surveyJson);
  //   setSurveyJson(surveyJson);
  //   console.log("Saved Survey JSON:", surveyJson);
  //   // call API here
  //   callback(saveNo, true);
  // };

  // creator.saveSurveyFunc = (saveNo, callback) => {
  //   let newJsonFromCreator = creator.JSON;
  //   newJsonFromCreator = addIdsToElements(newJsonFromCreator);

  //   setSurveyJson((prev) => {
  //     if (!prev) return newJsonFromCreator;

  //     const mergedPages = newJsonFromCreator.pages.map((page) => {
  //       const oldPage = prev.pages?.find((p) => p.name === page.name);

  //       if (!oldPage) return page;

  //       return {
  //         ...page,
  //         elements: page.elements.map((el) => {
  //           const oldEl = oldPage.elements?.find(
  //             (o) => o.uid === el.uid || o.name === el.name,
  //           );

  //           if (!oldEl) return el;

  //           return {
  //             ...el,
  //             ...oldEl,
  //             calculationJson: oldEl.calculationJson || el.calculationJson, // ✅ preserve
  //           };
  //         }),
  //       };
  //     });

  //     return {
  //       ...newJsonFromCreator,
  //       pages: mergedPages,
  //     };
  //   });

  //   callback(saveNo, true);
  // };

  // function preserveUidsById(oldJson, newJson) {
  //   if (!oldJson?.pages || !newJson?.pages) return newJson;

  //   const clone = JSON.parse(JSON.stringify(newJson)); // deep clone

  //   clone.pages = clone.pages.map((newPage) => {
  //     // 🔎 find matching old page by ID
  //     const oldPage = oldJson.pages.find((p) => p.id === newPage.id);

  //     // ✅ preserve page uid
  //     if (oldPage?.uid && newPage.uid) {
  //       newPage.uid = oldPage.uid;
  //     }

  //     // ---- elements ----
  //     if (newPage.elements?.length) {
  //       newPage.elements = newPage.elements.map((newEl) => {
  //         if (!oldPage?.elements) return newEl;

  //         // 🔎 find matching old element by ID
  //         const oldEl = oldPage.elements.find((o) => o.id === newEl.id);

  //         // ✅ preserve element uid
  //         if (oldEl?.uid && newEl.uid) {
  //           newEl.uid = oldEl.uid;
  //         }

  //         return newEl;
  //       });
  //     }

  //     return newPage;
  //   });

  //   return clone;
  // }

  // creator.saveSurveyFunc = (saveNo, callback) => {
  //   let builderJson = creator.JSON; // FULL SURVEYJS DATA
  //   console.log("JSON FOUND", surveyJson, addIdsToElements(creator.JSON));
  //   // builderJson = addIdsToElements(builderJson);

  //   setSurveyJson((prev) => {
  //     if (!prev) return builderJson;

  //     // merge builder structure with custom logic
  //     const mergedPages = builderJson.pages.map((page) => {
  //       // const oldPage = prev.pages?.find((p) => p.name === page.name);
  //       const oldPage = prev.pages?.find(
  //         (p) => p.uid === page.uid && p.id === page.id, // ✅ UID ONLY
  //       );

  //       if (!oldPage) return page;

  //       return {
  //         ...page, // builder data (required, alignment, etc)
  //         elements: page.elements.map((el) => {
  //           const oldEl = oldPage.elements?.find(
  //             (o) => o.uid === el.uid && o.id === el.id,
  //             // || o.name === el.name,
  //           );

  //           if (!oldEl) return el;

  //           return {
  //             ...el, // builder properties
  //             ...oldEl, // custom fields
  //             calculationJson: oldEl.calculationJson || el.calculationJson,
  //             rules: oldEl.rules || el.rules,
  //             meta: oldEl.meta || el.meta,
  //           };
  //         }),
  //       };
  //     });

  //     return {
  //       ...builderJson, // full SurveyJS schema
  //       pages: mergedPages,
  //     };
  //   });

  //   callback(saveNo, true);
  // };

  // creator.saveSurveyFunc = (saveNo, callback) => {
  //   let builderJson = creator.JSON; // SurveyJS JSON

  //   // Step 1: Add ids + uids (SurveyJS will generate new uids)
  //   const withIds = addIdsToElements(builderJson);

  //   // Step 2: Restore old uids using id matching
  //   const reconciledJson = preserveUidsById(surveyJson, withIds);

  //   setSurveyJson((prev) => {
  //     if (!prev) return reconciledJson;

  //     const mergedPages = reconciledJson?.pages.map((page) => {
  //       const oldPage = prev.pages?.find(
  //         (p) => p.id === page.id && p.uid === page.uid,
  //       );

  //       if (!oldPage) return page;

  //       return {
  //         ...page,
  //         elements: page.elements.map((el) => {
  //           const oldEl = oldPage.elements?.find(
  //             (o) => o.id === el.id && o.uid === el.uid,
  //           );

  //           if (!oldEl) return el;

  //           return {
  //             ...el,
  //             ...oldEl,
  //             calculationJson: oldEl.calculationJson || el.calculationJson,
  //             rules: oldEl.rules || el.rules,
  //             meta: oldEl.meta || el.meta,
  //           };
  //         }),
  //       };
  //     });

  //     return {
  //       ...reconciledJson,
  //       pages: mergedPages,
  //     };
  //   });

  //   callback(saveNo, true);
  // };

  function addIdsRecursively(node) {
    if (!node || typeof node !== "object") return node;

    const newNode = {
      ...node,
      id: node.id || node.name || crypto.randomUUID(),
      uid: node.uid || crypto.randomUUID(),
    };

    if (Array.isArray(node.elements)) {
      newNode.elements = node.elements.map((child) => addIdsRecursively(child));
    }

    return newNode;
  }

  function addIdsToElements(surveyJson) {
    if (!surveyJson?.pages) return surveyJson;

    return {
      ...surveyJson,
      pages: surveyJson.pages.map((page) => addIdsRecursively(page)),
    };
  }

  function preserveUidsRecursively(oldNode, newNode) {
    if (!newNode || typeof newNode !== "object") return newNode;

    let result = { ...newNode };

    // Match by id → restore uid
    if (oldNode?.id && newNode?.id && oldNode.id === newNode.id) {
      if (oldNode.uid) result.uid = oldNode.uid;
    }

    if (Array.isArray(newNode.elements)) {
      result.elements = newNode.elements.map((child) => {
        const matchingOldChild = oldNode?.elements?.find(
          (o) => o.id === child.id,
        );
        return preserveUidsRecursively(matchingOldChild, child);
      });
    }

    return result;
  }

  function preserveUidsById(oldJson, newJson) {
    if (!oldJson?.pages || !newJson?.pages) return newJson;

    return {
      ...newJson,
      pages: newJson.pages.map((newPage) => {
        const oldPage = oldJson.pages.find((p) => p.id === newPage.id);
        return preserveUidsRecursively(oldPage, newPage);
      }),
    };
  }

  // function mergeNodes(oldNode, newNode) {
  //   if (!newNode) return newNode;

  //   // Start with old custom data
  //   let merged = {
  //     ...oldNode, // custom/meta
  //     ...newNode, // UI schema (latest SurveyJS state wins)
  //   };

  //   // Explicitly preserve custom-only fields
  //   if (oldNode) {
  //     merged = {
  //       ...merged,
  //       calculationJson: oldNode.calculationJson || newNode.calculationJson,
  //       rules: oldNode.rules || newNode.rules,
  //       meta: oldNode.meta || newNode.meta,
  //     };
  //   }

  //   // 🔁 Recursive merge for nested elements
  //   if (Array.isArray(newNode.elements)) {
  //     merged.elements = newNode.elements.map((child) => {
  //       const oldChild = oldNode?.elements?.find(
  //         (o) => o.id === child.id && o.uid === child.uid,
  //       );
  //       return mergeNodes(oldChild, child);
  //     });
  //   }

  //   return merged;
  // }
  function mergeNodes(oldNode = {}, newNode) {
    if (!newNode) return newNode;

    const merged = {};

    // 1️⃣ Copy ONLY keys that exist in newNode
    Object.keys(newNode).forEach((key) => {
      merged[key] = newNode[key];
    });

    // 2️⃣ Preserve selected custom keys from oldNode
    PRESERVE_KEYS.forEach((key) => {
      if (oldNode[key] !== undefined && merged[key] === undefined) {
        merged[key] = oldNode[key];
      }
    });

    // 3️⃣ Recursive merge for elements
    if (Array.isArray(newNode.elements)) {
      merged.elements = newNode.elements.map((child) => {
        const oldChild = oldNode?.elements?.find((o) => o.id === child.id);
        return mergeNodes(oldChild, child);
      });
    }

    return merged;
  }

  // creator.saveSurveyFunc = (saveNo, callback) => {
  //   let builderJson = creator.JSON; // SurveyJS JSON

  //   console.log("JSON FOUND", creator.JSON);

  //   // Step 1: Add ids + uids
  //   const withIds = addIdsToElements(builderJson);

  //   // Step 2: Restore old uids using id matching
  //   const reconciledJson = preserveUidsById(surveyJson, withIds);

  //   setSurveyJson((prev) => {
  //     // ---------- SAFETY NORMALIZATION ----------
  //     const safeReconciled = {
  //       ...reconciledJson,
  //       pages: Array.isArray(reconciledJson?.pages) ? reconciledJson.pages : [],
  //     };

  //     if (!prev?.pages) {
  //       // Ensure at least one page exists
  //       return {
  //         ...safeReconciled,
  //         pages:
  //           safeReconciled.pages.length > 0
  //             ? safeReconciled.pages
  //             : [
  //                 {
  //                   name: "page1",
  //                   title: "Page Container",
  //                   elements: [],
  //                 },
  //               ],
  //       };
  //     }

  //     // ---------- MERGE ----------
  //     const mergedPages = safeReconciled.pages.map((page) => {
  //       const oldPage = prev.pages?.find(
  //         (p) => p?.id === page.id && p?.uid === page.uid,
  //       );

  //       if (!oldPage) {
  //         return {
  //           ...page,
  //           elements: Array.isArray(page.elements) ? page.elements : [],
  //         };
  //       }

  //       return {
  //         ...page,
  //         elements: Array.isArray(page.elements)
  //           ? page.elements.map((el) => {
  //               const oldEl = oldPage.elements?.find(
  //                 (o) => o?.id === el.id && o?.uid === el.uid,
  //               );

  //               if (!oldEl) return el;

  //               return {
  //                 ...el,
  //                 ...oldEl,
  //                 calculationJson: oldEl.calculationJson || el.calculationJson,
  //                 rules: oldEl.rules || el.rules,
  //                 meta: oldEl.meta || el.meta,
  //               };
  //             })
  //           : [],
  //       };
  //     });

  //     // ---------- FINAL NORMALIZATION ----------
  //     return {
  //       ...safeReconciled,
  //       pages:
  //         mergedPages.length > 0
  //           ? mergedPages
  //           : [
  //               {
  //                 name: "page1",
  //                 title: "Page Container",
  //                 elements: [],
  //               },
  //             ],
  //     };
  //   });

  //   callback(saveNo, true);
  // };

  creator.saveSurveyFunc = (saveNo, callback) => {
    let builderJson = creator.JSON;

    // console.log("Creator JSON", creator.JSON);
    // if (builderJson?.pages?.length === 1 && !builderJson?.pages[0]?.elements) {
    //   setSurveyJson({
    //     pages: [{ name: "page1", title: "Page Container", elements: [] }],
    //   });
    //   callback(saveNo, true);
    //   return;
    // }

    // Step 1: assign ids + uids recursively
    const withIds = addIdsToElements(builderJson);

    // Step 2: restore old uids recursively
    const reconciledJson = preserveUidsById(surveyJson, withIds);
    console.log("Recond", reconciledJson);

    setSurveyJson((prev) => {
      if (!prev?.pages) return reconciledJson;

      // const mergedPages = reconciledJson && reconciledJson?.pages.map((page) => {
      //   const oldPage = prev.pages.find((p) => p.id === page.id);
      //   return mergeNodes(oldPage, page);
      // });

      const mergedPages = Array.isArray(reconciledJson?.pages)
        ? reconciledJson.pages.map((page) => {
            const oldPage = prev.pages.find((p) => p.id === page.id);
            return mergeNodes(oldPage, page);
          })
        : [];

      return {
        ...reconciledJson,
        pages:
          mergedPages.length > 0
            ? mergedPages
            : [
                {
                  name: "page1",
                  title: "Page Container",
                  elements: [],
                },
              ],
      };
    });

    callback(saveNo, true);
  };

  return (
    <>
      <div
        style={{
          height: "100vh",
          marginTop: showDeleteButton ? "-55px" : "0px",
        }}
      >
        {showDeleteButton && (
          <div
            style={{
              display: "flex",
              position: "relative",
              top: "-17px",
              right: "80px",

              justifyContent: "flex-end",
            }}
          >
            <button
              className="danger"
              type="button"
              style={{
                marginRight: "70px",
                width:"7vw"
              }}
              onClick={() => setShowDeleteModal(true)}
            >
              Delete All
            </button>
          </div>
        )}
        {/* Rendering the builder */}
        <SurveyCreatorComponent creator={creator} />
      </div>
      {/* Questionnaire settings panel */}
      <div
        ref={questionnairePanelRef}
        style={{
          position: "fixed",
          right: 0,
          top: 0,
          height: "100%",
          width: 450,
          background: "#FFF",
          boxShadow: "-4px 0 12px rgba(0,0,0,0.08)",
          zIndex: 9999,
          overflow: "auto",
          borderTopLeftRadius: 14,
          padding: 12,
          transition: "all 0.3s ease-in-out",
          transform: showQuestionnairePanel
            ? "translateX(0)"
            : "translateX(103%)",
          // This ensures the element is always in DOM for smooth transitions
          visibility: showQuestionnairePanel ? "visible" : "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "sticky",
            top: -12,
            background: "#fff",
            zIndex: 10,
            borderBottom: "1px solid #a4bae0",
            paddingBottom: 15,
            marginBottom: 8,
          }}
        >
          <h4 style={{ margin: 0 }}>Control settings</h4>
          <button
            type="button"
            title="Close"
            style={{
              padding: "5px",
            }}
            onClick={() => setShowQuestionnairePanel(false)}
          >
            ❌
          </button>
        </div>
        <QuestionnaireSettings
          survey={surveyJson}
          selectedElement={selectedElement}
          questionnaireId={questionnaireId}
          onSurveyChange={setSurveyJson}
        />
      </div>
      {showDeleteModal && (
        <FieldDeleteModal
          creator={creator}
          setShowDeleteModal={setShowDeleteModal}
          showDeleteModal={showDeleteModal}
          setSurveyJson={setSurveyJson}
          questionnaireId={questionnaireId}
          setLoad={setLoad}
          loadQuestionData={loadQuestionData}
        />
      )}
      {/* Questionnaire settings panel icon which will be appended dynamically */}
      <div style={{ display: "none" }}>
        <div id="questionnaire-icon-svg">
          <QuestionnaireIcon />
        </div>
      </div>
    </>
  );
}
